import { viewerScript } from './platform/viewerScript';

export const { createControllers, initAppForPage } = viewerScript;
// This file must export a named export of "createControllers"
